if (!customElements.get('fit-banner-slider')) {
    customElements.define('fit-banner-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.isConnectedSetup) return;
        this.isConnectedSetup = true;
        this.slides = Array.from(this.querySelectorAll('[data-banner-slide]'));
        this.currentIndex = 0;
        this.interval = Number(this.dataset.interval) || 8000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = this.reducedMotion;
        this.onPrevious = () => this.show(this.currentIndex - 1);
        this.onNext = () => this.show(this.currentIndex + 1);
        this.onToggle = () => {
          this.paused = !this.paused;
          this.updateToggle();
          this.restart();
        };
        this.querySelector('[data-banner-previous]')?.addEventListener('click', this.onPrevious);
        this.querySelector('[data-banner-next]')?.addEventListener('click', this.onNext);
        this.querySelector('[data-banner-toggle]')?.addEventListener('click', this.onToggle);
        this.onVisibility = () => document.hidden ? this.stop() : this.restart();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.updateToggle();
        this.restart();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.querySelector('[data-banner-previous]')?.removeEventListener('click', this.onPrevious);
        this.querySelector('[data-banner-next]')?.removeEventListener('click', this.onNext);
        this.querySelector('[data-banner-toggle]')?.removeEventListener('click', this.onToggle);
        this.isConnectedSetup = false;
      }

      show(index) {
        this.currentIndex = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          if (active) slide.removeAttribute('tabindex');
          else slide.setAttribute('tabindex', '-1');
        });
        const counter = this.querySelector('[data-banner-current]');
        if (counter) counter.textContent = String(this.currentIndex + 1);
        this.restart();
      }

      updateToggle() {
        const button = this.querySelector('[data-banner-toggle]');
        if (!button) return;
        button.classList.toggle('is-paused', this.paused);
        button.setAttribute('aria-label', this.paused ? 'Play automatic banner rotation' : 'Pause automatic banner rotation');
      }

      restart() {
        this.stop();
        if (!this.paused && !document.hidden && this.slides.length > 1) {
          this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.interval);
        }
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  if (!window.fitHomeInteractionEvents) {
    window.fitHomeInteractionEvents = true;
    document.addEventListener('click', (event) => {
      const control = event.target.closest('[data-carousel-target][data-carousel-direction]');
      if (!control) return;
      const home = control.closest('.fit-home');
      const track = home?.querySelector(`#${CSS.escape(control.dataset.carouselTarget)}`);
      if (!track) return;
      const direction = Number(control.dataset.carouselDirection) || 1;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const firstCard = track.firstElementChild;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const cardStep = firstCard ? firstCard.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * cardStep, behavior });
    });

    const updateCarouselControls = (track) => {
      if (!track?.id) return;
      const controls = document.querySelectorAll(`[data-carousel-target="${CSS.escape(track.id)}"]`);
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const progress = maxScroll ? Math.min(1, Math.max(0, track.scrollLeft / maxScroll)) : 0;
      controls.forEach((button) => {
        const direction = Number(button.dataset.carouselDirection);
        button.disabled = direction < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= maxScroll - 2;
        button.setAttribute('aria-disabled', String(button.disabled));
        const fill = button.closest('.fit-carousel-controls')?.querySelector('[data-carousel-progress-fill]');
        if (fill) fill.style.width = `${Math.max(34, progress * 100)}%`;
      });
    };
    const revealObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -35px 0px' })
      : null;

    if (revealObserver) document.documentElement.classList.add('fit-motion-ready');

    window.fitHomeRefresh = (root = document) => {
      const selectors = '.fit-reel-track, .fit-review-track, .fit-product-track';
      const tracks = [...root.querySelectorAll(selectors)];
      if (root.matches?.(selectors)) tracks.unshift(root);
      tracks.forEach((track) => {
        if (track.dataset.fitCarouselInitialized) return;
        track.dataset.fitCarouselInitialized = 'true';
        updateCarouselControls(track);
        let scheduled = false;
        track.addEventListener('scroll', () => {
          if (scheduled) return;
          scheduled = true;
          window.requestAnimationFrame(() => {
            updateCarouselControls(track);
            scheduled = false;
          });
        }, { passive: true });
        window.addEventListener('resize', () => updateCarouselControls(track), { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(() => updateCarouselControls(track)).observe(track);
      });

      const revealSelector = '.fit-home [data-fit-reveal], .fit-home [data-fit-stagger] > *';
      const revealTargets = [...root.querySelectorAll(revealSelector)];
      if (root.matches?.(revealSelector)) revealTargets.unshift(root);
      revealTargets.forEach((target) => {
        if (target.classList.contains('is-in-view')) return;
        if (revealObserver) revealObserver.observe(target);
        else target.classList.add('is-in-view');
      });
    };

    window.fitHomeRefresh();
    document.addEventListener('shopify:section:load', (event) => window.fitHomeRefresh(event.target));
  }
